module.exports = ".table-responsive {\n  height: 100%;\n  overflow: visible; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/attachment-account-client/attachment-grid/attachment-grid.component.scss
// module id = ./src/app/account-client/component/account-client-details/attachment-account-client/attachment-grid/attachment-grid.component.scss
// module chunks = main